/* unplugin-vue-components disabled */import script from "./resourceCarousel.vue?vue&type=script&lang=js"
export * from "./resourceCarousel.vue?vue&type=script&lang=js"

import "./resourceCarousel.vue?vue&type=style&index=0&id=ea929a10&lang=scss"

const __exports__ = script;

export default __exports__